import api from '../index';
import { User } from '../../types/user';

export const userService = {
  getAll: () => 
    api.get('/users'),
  
  getOne: (id: number) => 
    api.get(`/users/${id}`),
  
  create: (data: Partial<User>) => 
    api.post('/users', data),
  
  update: (id: number, data: Partial<User>) => 
    api.put(`/users/${id}`, data),
  
  delete: (id: number) => 
    api.delete(`/users/${id}`),
  
  approve: (userId: number) => 
    api.post(`/users/${userId}/approve`),
};